/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    CAMPSITE_AVAILABILITY_DATE_RANGE_STARTED,
    CAMPSITE_AVAILABILITY_DATE_RANGE_SUCCESS,
    CAMPSITE_AVAILABILITY_DATE_RANGE_FAIL,
    CAMPSITE_AVAILABILITY_ALL_SUCCESS,
} from '../constants';

const STATUSENUM = Object.freeze({
    init: 'Campsite availability call initiated',
    success: 'Campsite availability call succeeded',
    fail: 'Campsite availability call failed: ',
});

const INITIALSTATE = { status: '', isLoading: false, results: {} };
/*
 * Will end up looking like this:
 *{
 *  status: '',
 *  availabilityRanges: [{
 *    siteId: id,
 *    availabilityRange: {
 *      date_year: #,
 *      date_month: #,
 *      date_day: #,
 *      is_available: bool,
 *      status: str
 *    }
 *  }]
 *}
 * (for reference only, check camping swagger.json if debugging)
 */

export default function campsiteAvailabilityDateRange(state = INITIALSTATE, action) {
    const newState = { ...state };
    switch (action.type) {
        case CAMPSITE_AVAILABILITY_DATE_RANGE_STARTED:
            newState.status = STATUSENUM.init;
            newState.isLoading = true;
            return newState;

        case CAMPSITE_AVAILABILITY_ALL_SUCCESS:
            newState.results = { [action.id]: action.payload };
            newState.status = STATUSENUM.success;
            newState.isLoading = false;
            return newState;

        case CAMPSITE_AVAILABILITY_DATE_RANGE_SUCCESS:
            newState.results = { [action.id]: action.payload };
            newState.status = STATUSENUM.success;
            newState.isLoading = false;
            return newState;

        case CAMPSITE_AVAILABILITY_DATE_RANGE_FAIL:
            newState.status = STATUSENUM.fail + action.payload;
            newState.isLoading = false;
            return newState;

        default:
            return newState;
    }
}
